
  export const TryOn = () => {

    return (
        <svg width="16" height="16" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_4_792" maskUnits="userSpaceOnUse" x="0" y="0" width="18" height="14">
            <rect width="18" height="14" fill="#D9D9D9"/>
            </mask>
            <g mask="url(#mask0_4_792)">
                <path d="M16.8616 11.995C2.40403 11.995 2.40403 11.995 2.40403 11.995C-1.96918 11.995 2.40396 11.995 0.999932 11.995C0.999932 8.41614 3.38846 5.2896 6.82479 4.34662L7.94005 5.54244C6.57286 5.74935 5.31166 6.38385 4.31575 7.37976C3.08295 8.61255 2.40403 10.2516 2.40403 11.995C2.40403 11.995 2.40403 11.995 15.4578 11.995C15.4578 10.2516 14.7788 8.61255 13.5461 7.37976C12.55 6.38385 11.2888 5.74935 9.92162 5.54244L11.0369 4.34662C14.4731 5.2896 16.8616 8.41614 16.8616 11.995Z" fill="black"/>
                <path d="M12.5775 2.0545L10.8067 3.95305L9.61853 5.22697L10.9663 2.0545H12.5775Z" fill="black"/>
                <path d="M10.4905 2.0545L9.03937 5.47034C9.00344 5.46956 8.96737 5.4693 8.93144 5.4693C8.89524 5.4693 8.85931 5.46956 8.82338 5.47034L7.37225 2.0545H10.4905Z" fill="black"/>
                <path d="M6.89635 2.0545L8.24408 5.22697L5.28528 2.0545H6.89635Z" fill="black"/>
                <path d="M7.4854 0L6.88762 1.61562H5.24048L6.55305 0H7.4854Z" fill="black"/>
                <path d="M9.90809 0L10.506 1.61562H7.35468L7.95246 0H9.90809Z" fill="black"/>
                <path d="M11.3072 0L12.6199 1.61562H10.9727L10.3749 0H11.3072Z" fill="black"/>
            </g>
        </svg>

    )
  }